export const cluster = {
    clusterDiscription:
        '選択テーマに内包されている技術群（クラスタ）の解析結果を企業が所属しているバリューチェーン毎に表示しています。\nクラスタのバブルを選択すると、画面下部より詳細が確認できます。',
    title: 'クラスタ',
    tooltip:
        'UIで指定した技術クラスタに対して、イノベーションの評価と市場期待値の軸で評価結果が示されます。当該技術クラスタの評価結果を基にして、ユーザーは戦略オプションの初期評価が可能になります。例えば、市場期待値が高いが相対的なイノベーション評価が低い技術クラスタ（開発テーマ）に対しては、技術（知財）開発の投資をすべきで、当該技術クラスタでイノベーションの評価が高いスタートアップを中心としてアライアンスを検討ができます。一方、相対的なイノベーションの評価（スコア）が高いが市場期待値が低い技術クラスタ（開発テーマ）に対しては、事業（製造、販売の効率化又はデータ統合による事業効率化目的の）開発の投資をすべきで、当該技術クラスタでイノベーションの評価が高い事業会社を中心としてアライアンスを検討ができます。',
    tableIPC: '技術区分',
    tableTitle: 'メイン技術区分名',
    tableRate: '因子負荷量（クラスタへの寄与度）',
    tableCount: '特許出願件数',
    chartTitle1: '戦略オプション（アライアンスの戦略選択）',
    chartTitle2: '強み/弱み評価',
    tableTitleName: '選択したクラスタの詳細',
    selectedCompanyIncluded: '選択した企業を含むクラスタ',
    selectedCompanyExcluded: '選択した企業を含まないクラスタ',
    selectedCompanyWithLabel: '選択した企業を含ラベル',

    chartsTitle: '全体技術動向',
    clusterSelectMode: 'クラスタ選択',
    labelFixMode: 'ラベル固定',
    labelClusterId: 'クラスタID',
    labelClusterName: 'クラスタ名',
    labelPatentCount: '特許数',
    labelShowOnlyCluster: 'クラスタIDのみ',
    howToReadButton: 'バブルチャートの見方',
    copy: 'コピー',
    download: 'ダウンロード',
    aboutTheXAxis: 'X軸の設定項目について',
    aboutTheYAxis: 'Y軸の設定項目について',
    yAxisUnit: '(10億円)',
    yAxisUnitOfBusinessAmount: '(百万米ドル)',
    markPointLabel1: '技術シーズの探索を行う領域',
    markPointLabel2: '技術開発が進む可能性が高い領域',
    markPointLabel3: '技術トレンドとなっている領域',
    markPointLabel4: '技術的に成熟しつつある領域',
    labelAlert: 'クラスタを選択するにはラベル固定をオフにしてください',
    clusterHighlight: 'クラスタをハイライト',
    highlightCompany: '企業',
    highlightPlaceholder: '英語で入力してください',
    favoriteCompany: 'お気に入りから選択',
    companyName: '企業名',
    other: 'その他',

    chart1XAxisScore: 'スコア',
    chart1XAxisImpact: 'インパクト',
    chart1XAxisStage: '成長ステージ',
    chart1YAxisScale: '事業規模[千米ドル]',
    chart1YAxisAmount: 'マイノリティ出資額[百万円]',

    marketability: '市場期待値[百万円]',
    clusterid: 'クラスタ',
    ipcCode: '技術区分',
    ipcMain: '筆頭IPC',
    ipcName: '技術区分名',
    patentcount: '特許出願件数',

    // Cluster Comparison table
    titleClusterComparison: 'クラスタ比較',
    tblClusterId: 'クラスタID',
    tblIPCMain: '筆頭IPC',
    tblClusterLabel: 'クラスタ名',
    tblScore: 'スコア',
    tblScoredeviation: 'スコア偏差値',
    tblInvestment: 'マイノリティ出資額[百万円]',
    tblInvestmentdeviation: 'マイノリティ出資額偏差値',
    tblWhitespace: 'ホワイトスペース',
    tblWhitespacedeviation: 'ホワイトスペース偏差値',
    tblRelativeipstrength: '相対的知財力',
    tblOverallscore: '総合点',
    // Growing Clusters table
    titleGrowingCluster: '成長クラスタ',
    GrowingClusterDESC: 'グローバルで算出 i.e. "SELECT a COUNTRY = ALL"',
    tblGrowingClusterName: 'クラスタラベル',
    tblGrowingClusterId: 'クラスタID',
    tblGrowingGrowthRate: '成長率',
    tblGrowingScore: 'スコア',
    tblGrowingMarketability: 'マイノリティ出資額[百万円]',
    // Cluster’s Detail
    // 未使用
    titleClusterDetail: '選択したクラスタの詳細',
    ipcNameMain: 'メイン技術区分名',

    // New table with all the patents IPC
    patentTableTitile: '選択したクラスタの特許一覧 (インパクト上位100件まで)',
    patentRadioTitle: 'クラスタ内の全ての特許を表示する',
    downloadTitle: '完全な特許一覧をダウンロード',
    tableColumnPublication: '公開番号／特許番号',
    tableColumnIPCMain: '筆頭IPC',
    tableColumnIPCOther: 'その他のIPC',
    tableColumnIPCTitle: '発明の名称',
    tableColumnOwner: '特許保有企業',
    tableColumnInventor: '発明者',
    tableColumnFLQ: '因子負荷量',
    tableColumnImpact: 'インパクト',
    tableColumnApplicationYear: '出願年',

    // 設定画面
    setting: '設定',
    size: 'バブルの大きさ',
    yAxisLabel: 'Y軸を対数変換',
    showActualValue: '軸に実数値を併記',
    zoomSlider: 'ズームスライダー',
    nonDisplay: '表示しない',
    aboutTheAnalyticalAxis: '4領域の説明表示',
    initButton: '設定の初期化',

    // 企業一覧作成CSV
    companyCsv: {
        title: '企業一覧CSV作成',
        clusterIdTitle: 'クラスタIDの指定',
        clusterIdPlaceholder: 'クラスタIDを入力してください',
        clusterIdExample: '入力例 Cluster001、Cluster002 など',
        sortTitle: 'ソート順の選択',
        sortCompanyName: '企業名',
        sortBusinessOverview: '企業規模',
        sortNumberOfEmployees: '従業員数',
        sortAppliedCountry: '国',
        sortNumberOfPatents: '特許出願数',
        sortImportantPatentsCount: '重要特許数',
        domainTitle: '作成対象の領域',
        domain1: '領域1',
        domain2: '領域2',
        domain3: '領域3',
        domain4: '領域4',
        downloadButton: '企業一覧CSV作成',
        downloading: '企業一覧CSV作成中...'
    }
}
